import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '@/api';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await authAPI.adminLogin(username, password);
      login(response.data.user, response.data.token);
      toast.success('Admin login successful');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error('Invalid admin credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-secondary to-white">
      <div className="w-full max-w-md p-8">
        <div className="bg-white rounded-2xl border border-border/40 p-8 shadow-lg">
          <div className="mb-8 text-center">
            <h1 className="font-heading text-3xl font-bold text-[#2C3333] mb-2">Admin Login</h1>
            <p className="text-[#4B5563]">Access the admin panel</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-testid="admin-login-form">
            <div>
              <Label htmlFor="username" className="text-[#2C3333]">Username</Label>
              <Input
                id="username"
                data-testid="admin-username-input"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="mt-2 rounded-lg border-border/60 bg-white/50 focus:ring-2 focus:ring-primary/20 focus:border-primary h-12"
                required
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-[#2C3333]">Password</Label>
              <Input
                id="password"
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 rounded-lg border-border/60 bg-white/50 focus:ring-2 focus:ring-primary/20 focus:border-primary h-12"
                required
              />
            </div>

            <Button
              type="submit"
              data-testid="admin-login-btn"
              disabled={loading}
              className="w-full bg-primary hover:bg-primary-hover text-white rounded-full py-6 font-medium transition-all duration-300 shadow-sm hover:shadow-md"
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <button
              data-testid="back-to-home-btn"
              onClick={() => navigate('/')}
              className="text-primary hover:underline font-medium text-sm"
            >
              Back to Home
            </button>
          </div>

          <div className="mt-6 p-4 bg-secondary/50 rounded-lg">
            <p className="text-xs text-[#4B5563] text-center">
              Default credentials: admin / admin123
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;